import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { CONTACT_CONFIG } from '../config/contact';

export default function Reimbursement() {
  // Utilisation des variables de configuration centralisées
  const contactInfo = CONTACT_CONFIG;
  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Politique de Remboursement</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
              >
                Accueil
              </NavLink>{" "}
              /{" "}
              <span className="text-gray-300">Politique de Remboursement</span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Droit au remboursement
              </h2>
              <p className="text-base leading-relaxed">
                Chez TVDIAMO, nous nous engageons à garantir votre satisfaction.
                C'est pourquoi nous offrons une politique de remboursement de 15
                jours pour tous nos utilisateurs. Si, pour une raison
                quelconque, vous n'êtes pas satisfait de nos services, vous
                pouvez demander un remboursement dans les 15 jours suivant votre
                achat.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                2. Conditions de remboursement
              </h2>
              <p className="text-base leading-relaxed">
                Pour être éligible à un remboursement, les conditions suivantes
                doivent être remplies :
              </p>
              <ul className="list-disc list-inside pt-2">
                <li>
                  La demande doit être effectuée dans les 15 jours suivant la
                  date d'achat.
                </li>
                <li>
                  Vous devez fournir une preuve d'achat valide, comme votre reçu
                  ou email de confirmation.
                </li>
                <li>
                  Les remboursements ne sont pas disponibles si vous avez déjà
                  utilisé plus de 50% de votre période d'abonnement.
                </li>
              </ul>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                3. Processus de demande
              </h2>
              <p className="text-base leading-relaxed">
                Pour demander un remboursement, suivez ces étapes :
              </p>
              <ol className="list-inside list-decimal pt-2">
                <li>
                  Contactez notre équipe de support via WhatsApp ou email.
                </li>
                <li>
                  Fournissez votre numéro de commande et la raison du
                  remboursement.
                </li>
                <li>
                  Joignez la preuve d'achat (reçu ou email de confirmation).
                </li>
              </ol>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                4. Méthode de remboursement
              </h2>
              <p className="text-base leading-relaxed">
                Si votre demande de remboursement est approuvée, le montant sera
                remboursé via la même méthode de paiement que vous avez utilisée
                pour votre achat. Le temps de traitement peut varier selon votre
                fournisseur de paiement.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">5. Contactez-nous</h2>
              <p className="text-base leading-relaxed mb-4">
                Pour toute question sur cette politique de remboursement ou pour
                exercer vos droits, vous pouvez nous contacter via :
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>Email : {contactInfo.email}</li>
                <li>
                  WhatsApp :{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Cliquez ici pour nous contacter
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Merci d'avoir choisi {contactInfo.companyName}. Nous sommes fiers de garantir
                votre confidentialité et de vous offrir un service de haute
                qualité sans compromettre votre sécurité ou votre anonymat.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
